import React, { useEffect, useState } from 'react'
import ContactCards from './components/ContactCards'
import { Icons, Images } from '../../assets'
import ContactTable from './components/ContactTable'
import ModalDropdown from '../../component/ModalDropdown'
import classes from "./style.module.scss"
import Button from '../../component/Button'
import SearchBox from '../../component/SearchBox';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux'
import { saveLoadingState } from '../../redux/reducers/loadingSlice'
import Exported from '../../service/endpoints'
import { Toast } from '../../service/toast'
import request from '../../service'
import { StatusCode, StatusColor } from '../../helpers'
import moment from 'moment'
import { FormProvider, useForm } from 'react-hook-form'
import InputBox from '../../component/InputBox'

const ContactForm = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [searchInput, setSearchInput] = useState('')
  const [selectedId, setSelectedId] = useState(null)
  const [selectedInfo, setSelectedInfo] = useState(null)
  const [contactCount, setContactCount] = useState(null)
  const [isReply, setIsReply] = useState(false)
  const [isButton, setIsButton] = useState(true)
  const [page, setPage] = useState(1)
  const [sortConfig, setSortConfig] = useState(null);
  const [isLoading, setisLoading] = useState(null);
  const [userList, setUserList] = useState({})
  const dispatch = useDispatch()

  const formMethods = useForm({
    mode: 'onSubmit',
  });
  const {
    handleSubmit,
    formState: { errors },
    register,
    trigger,
  } = formMethods;

  useEffect(() => {
    getContactCount()
  }, [])

  useEffect(() => {
    getUserList()
  }, [page, sortConfig, searchInput])

  useEffect(() => {
    if (selectedId && isModalOpen) {
      getContactInfo(selectedId)
    }
  }, [selectedId, isModalOpen])

  const getUserList = async () => {
    setisLoading(true)
    let url = `${Exported.Endpoints.getContactForm}`
    let paramsObj = {
      page: page,
      limit: 10,
    }

    if (searchInput && searchInput !== '') {
      paramsObj['search'] = searchInput
    }
    if (sortConfig) {
      paramsObj['sort'] = sortConfig?.key
      paramsObj['sortOrder'] = sortConfig?.direction
    }

    await request({
      url: url,
      params: { ...paramsObj }
    }).then((res) => {
      if (res?.data?.status) {
        const obj = {
          result: res?.data?.data?.list,
          pageMeta: res?.data?.data?.pageMeta
        }
        setUserList(obj)
      }
    }).catch((err) => {
      console.log(err, "err")
      Toast({
        type: 'error',
        message: 'Unable to process the request!..'
      })
    })
    setisLoading(false)
  }

  const getContactCount = async () => {
    let url = `${Exported.Endpoints.getContactCount}`
    await request({
      url: url,
    }).then((res) => {
      if (res?.data?.status) {
        setContactCount(res?.data?.data)
      }
    }).catch((err) => {
      console.log(err, "err")
      Toast({
        type: 'error',
        message: 'Unable to process the request!..'
      })
    })
  }

  const getContactInfo = async (id) => {
    dispatch(saveLoadingState(true))
    let url = `${Exported.Endpoints.getContactFormByID}/${id}`
    await request({
      url: url,
    }).then((res) => {
      if (res?.data?.status) {
        setSelectedInfo(res?.data?.data)
      }
    }).catch((err) => {
      console.log(err, "err")
      Toast({
        type: 'error',
        message: 'Unable to process the request!..'
      })
    })
    dispatch(saveLoadingState(false))
  }

  const onSubmit = async (data) => {
    let url = `${Exported.Endpoints.sendReplyForContact}/${selectedId}`
    let requestedData = {
      message: data?.reason
    }
    dispatch(saveLoadingState(true))
    await request({
      url: url,
      method: Exported.APIMethods.POST,
      data: requestedData
    }).then(async (res) => {
      if (res?.data?.status) {
        await getUserList()
        await getContactCount()
        Toast({
          type: 'success',
          message: 'Email Sent successfully'
        })
      }
    }).catch((err) => {
      console.log(err, "err")
      Toast({
        type: 'error',
        message: 'Unable to process the request!..'
      })
    })
    closeModal()
    dispatch(saveLoadingState(false));
  }

  const handleChange = (value) => {
    setSearchInput(value)
  }

  const handleClick = (itemId) => {
    setSelectedId(itemId)
    setIsModalOpen(true)
  }

  const replyClick = () => {
    setIsReply(true)
    setIsButton(false)
  }
  const closeModal = () => {
    setIsReply(false)
    setSelectedId(null)
    setSelectedInfo(null)
    setIsButton(true)
    setIsModalOpen(false)
  }

  return (
    <div>
      <div className={`w-[100%] flex items-center justify-between`}>
        <div className={`layout-title`}>Contact Form</div>
        <div className='flex items-center'>
          <SearchBox className={''} value={searchInput} onChange={handleChange} placeholder={'Find by customer name,inquiry ID...'} />
        </div>
      </div>
      <div className='flex items-center justify-between mt-4'>
        <ContactCards
          contactsReceived={contactCount?.total}
          contactText={"Total Contact form received"}
          src={Images.mailReceive}
          backgroundColor={"#DAECFF"}
          color={"#3093FB"}
        />
        <ContactCards
          contactsReceived={contactCount?.closed}
          contactText={"Total Contact form resolved"}
          src={Images.mailResolved}
          backgroundColor={"#B6F4F4"}
          color={"#51C9C9"}
        />
        <ContactCards
          contactsReceived={contactCount?.pending}
          contactText={"Total Contact form pending"}
          src={Images.mailPending}
          backgroundColor={"#FFD3D0"}
          color={"#CB4A01"}
        />
      </div>
      <div className='mt-5'>
        <ContactTable
          searchInput={searchInput}
          page={page}
          setPage={setPage}
          sortConfig={sortConfig}
          setSortConfig={setSortConfig}
          isLoading={isLoading}
          setisLoading={setisLoading}
          userList={userList}
          setUserList={setUserList}
          handleView={handleClick}
          getContactCount={getContactCount}
          getUserList={getUserList}
        />
      </div>
      {isModalOpen &&
        <ModalDropdown isOpen={isModalOpen} closePopUp={closeModal} >
          <div className={`${classes.mainDiv} ${isReply ? `h-[550px]` : `h-[438px]`}  w-[906px]`} >
            <div className={`${classes.header}`}>
              <div className={`${classes.subHeader}`}>
                <p>Issue Details</p>
                <span style={{ background: `${StatusColor[selectedInfo?.status]}20`, color: StatusColor[selectedInfo?.status] }}>{StatusCode[selectedInfo?.status]}</span>
              </div>
              <>
                <CloseIcon className='cursor-pointer' onClick={() => closeModal()} />
              </>
            </div>
            <div className={`${classes.tableHeader}`}>
              <p className={`${classes.tableText}`}>Customer Information</p>
              <table className='mb-5'>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Mobile Number</th>
                    <th>Email</th>
                  </tr>

                  <tr>
                    <td>{selectedInfo?.user?.username}</td>
                    <td>{selectedInfo?.user?.role?.name}</td>
                    <td>{selectedInfo?.user?.mobileNumber}</td>
                    <td>{selectedInfo?.user?.email}</td>
                  </tr>
                </thead>
              </table>
            </div>

            <div className='mb-8'>
              <p className={`${classes.tableText}`}>Issue Details</p>
              <table>
                <tbody>
                  <tr>
                    <th>Subject</th>
                    <th>Date Submitted</th>
                    <th>Description</th>
                  </tr>

                  <tr>
                    <td>{selectedInfo?.subject}</td>
                    <td>{selectedInfo?.createdAt ? moment(selectedInfo?.createdAt)?.format('DD MMM YYYY') : '-'}</td>
                    <td>{selectedInfo?.message}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            {selectedInfo?.reply_to_customer ?
              <div className='mb-8'>
                <table>
                  <tbody>
                    <tr>
                      <th>Reply</th>
                    </tr>

                    <tr>
                      <td>{selectedInfo?.reply_to_customer}</td>
                    </tr>
                  </tbody>
                </table>
              </div> : null}
            <div className=' text-right'>
              {isButton && selectedInfo?.status !== 3 && selectedInfo?.reply_to_customer == null && <Button text={"Reply to Customer"} onClick={replyClick} smallBtn={true} style={{ width: "210px" }} />}
            </div>
            {isReply &&
              <div className='flex-col'>
                <p className={`${classes.reply}`}>Reply To Customer</p>
                <FormProvider {...formMethods}>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <InputBox
                      className={`w-[100%]`}
                      name={"reason"}
                      type={"textarea"}
                      {...register("reason", {
                        required: true,
                      })}
                      error={errors.reason}
                      messages={{
                        required: "Reply is required",
                      }}
                    />
                    <div className='flex justify-end'>
                      <Button text={"Send"} style={{ width: "130px", margin: '30px 0' }} smallBtn />
                    </div>
                  </form>
                </FormProvider>
              </div>
            }
            {selectedInfo?.admin_comment ?
              <div className='mb-8'>
                <table>
                  <tbody>
                    <tr>
                      <th>Internal Comment</th>
                    </tr>

                    <tr>
                      <td>{selectedInfo?.admin_comment}</td>
                    </tr>
                  </tbody>
                </table>
              </div> : null}
          </div>
        </ModalDropdown>}
    </div>
  )
}

export default ContactForm